define('checkPreInit/loadingErrors',[], function() {
    'use strict';
    var errors = {
        NOT_HTTPS: 'NOT_HTTPS',
        FETCH_VERSION: 'FETCH_VERSION',
        SELF_API_MISMATCH: 'SELF_API_MISMATCH',
        SERVER_API_MISMATCH: 'SERVER_API_MISMATCH',
        FOR_REPORTING: 'FOR_REPORTING',
        FETCH_SITE: 'FETCH_SITE',
        CAS_LOGIN: 'CAS_LOGIN',
        BUILD_MISMATCH: 'BUILD_MISMATCH',
        NO_SSO_BACKEND:'NO_SSO_BACKEND',
        INVALID_TICKET:'INVALID_TICKET',
        CAS_SESSION_CREATE_FAILURE:'CAS_SESSION_CREATE_FAILURE'
    };
    return errors;
});
